import "./BookData.css";

import Summary from "./summary/Summary";
import SummaryMobile from "./summaryMobile/SummaryMobile";
import DataForm from "./dataForm/DataForm";
import { Dispatch, FC, SetStateAction } from "react";
import { NewCarBookingSuccessResponse, RentalPrice } from "./../../api/types";
import { SelectOption, SelectOptionGroup } from "../ui/Select";

interface Props {
  offer: RentalPrice;
  setOffer: Dispatch<SetStateAction<RentalPrice | undefined>>;
  setBooking: Dispatch<
    SetStateAction<NewCarBookingSuccessResponse | undefined>
  >;
  places: SelectOption[] | SelectOptionGroup[];
  pickupPlace: SelectOption;
}

const BookData: FC<Props> = ({
  offer,
  setOffer,
  places,
  pickupPlace,
  setBooking,
}) => {
  return (
    <div className="tw-book-data-wrapper">
      <div className="tw-grid tw-grid-cols-12 tw-space-x-2">
        <div className="tw-col-span-12 md:tw-col-span-7">
          <SummaryMobile offer={offer} setOffer={setOffer} />
          <DataForm
            places={places}
            pickupPlace={pickupPlace}
            offer={offer}
            setBooking={setBooking}
            setOffer={setOffer}
          />
        </div>
        <div className="tw-hidden md:tw-col-span-5 md:tw-block tw-bg-gray-50">
          <Summary offer={offer} setOffer={setOffer} />
        </div>
      </div>
    </div>
  );
};

export default BookData;
